<template>
    <div class="buying-succ">
        <van-nav-bar left-arrow title="支付成功" @click-left="$router.push('/invest')" :z-index="10"></van-nav-bar>

        <div class="buying-succ-icon">   
            <van-icon class="good-job-o"  name="good-job-o" />
        </div>
        
        <div class="bs-title">恭喜您 成功买入 {{ productName }}</div>
        <div class="bs-amount">{{ amount * 100 | numFormat }}元</div>

        <div class="buying-succ-active">
            <van-button @click="$router.push('/user')" type="danger" size="large" class="buy">返回我的个人中心</van-button>
        </div>
    </div>
</template>

<script>
import {
    Icon,
    Toast,
    Dialog,
    Button,
    NavBar,
} from "vant";

export default {
    components: {
        [Icon.name]: Icon,
        [Toast.name]: Toast,
        [Dialog.name]: Dialog,
        [Button.name]: Button,
        [NavBar.name]: NavBar,
    },

    data() {
        return {
            id : '',
        };
    },

    created(){

    },

    methods: {
        
    }
};
</script>

<style lang="less" scoped>
.buying-succ {
    .buying-succ-active{
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        padding-bottom: 30px;
    }

    .buying-succ-icon{
        text-align: center;
        margin-top: 120px;

        i{
            color: #C1A76A;
            font-size: 100px;
        }
    }

    .bs-title{
        color: #575E66;
        text-align: center;
        font-size: 16px;
        margin-top: 20px;
    }

    .bs-amount{
        color: #C1A76A;
        text-align: center;
        font-size: 34px;
    }
}
</style>
